import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

type Props = {
  photos: string[];
  isOpen: boolean;
  onClose: () => void;
};

export const ImageModal: React.FC<Props> = ({ photos, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div
      className="modal"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0,0,0,0.85)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
      }}
      onClick={onClose}
    >
      <div
        style={{ width: "90%", maxWidth: "800px" }}
        onClick={(e) => e.stopPropagation()}
      >
        <Swiper
          modules={[Navigation, Pagination]}
          spaceBetween={20}
          slidesPerView={1}
          navigation
          pagination={{ clickable: true }}
        >
          {photos.map((photo, idx) => (
            <SwiperSlide key={idx}>
              <img
                src={photo}
                alt={`Slide ${idx}`}
                style={{
                  width: "100%",
                  maxHeight: "80vh",
                  objectFit: "cover",
                  borderRadius: 8,
                }}
              />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  );
};
